/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExternalEhrDocumentRelationType = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type ExternalEhrDocumentRelationType = typeof ExternalEhrDocumentRelationType[keyof typeof ExternalEhrDocumentRelationType];


export function instanceOfExternalEhrDocumentRelationType(value: any): boolean {
    for (const key in ExternalEhrDocumentRelationType) {
        if (Object.prototype.hasOwnProperty.call(ExternalEhrDocumentRelationType, key)) {
            if (ExternalEhrDocumentRelationType[key as keyof typeof ExternalEhrDocumentRelationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExternalEhrDocumentRelationTypeFromJSON(json: any): ExternalEhrDocumentRelationType {
    return ExternalEhrDocumentRelationTypeFromJSONTyped(json, false);
}

export function ExternalEhrDocumentRelationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrDocumentRelationType {
    return json as ExternalEhrDocumentRelationType;
}

export function ExternalEhrDocumentRelationTypeToJSON(value?: ExternalEhrDocumentRelationType | null): any {
    return value as any;
}

export function ExternalEhrDocumentRelationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ExternalEhrDocumentRelationType {
    return value as ExternalEhrDocumentRelationType;
}

